
export class TealiumConstants {
    static readonly emptyData: string = "";
}

export class SearchProperties {
    search_type: string = TealiumConstants.emptyData;                //Required  *
    search_city: string = TealiumConstants.emptyData;              //Suggested *
    search_state: string = TealiumConstants.emptyData;             //Suggested *
    search_country: string = TealiumConstants.emptyData;           //Suggested *
    search_destination: string = TealiumConstants.emptyData;       //Suggested *
    search_rate: string = TealiumConstants.emptyData;                //Suggested
    search_rate_value: string = TealiumConstants.emptyData;          //Suggested
    search_results: string = TealiumConstants.emptyData;                                                 //Suggested *
    sort_by: string = TealiumConstants.emptyData;                    //Suggested
    show_avaialbe: string = TealiumConstants.emptyData;              //Suggested
    search_month: string = TealiumConstants.emptyData;               //Additional *
    filter: string = TealiumConstants.emptyData;
    selectedDate: string = TealiumConstants.emptyData;
}

export class MemberProperties {
    member_id: string;                                                      //Required *
    customer_id: string = TealiumConstants.emptyData;                                                    //Required *
    customer_member_class: string = TealiumConstants.emptyData;                                          //Required *
    customer_expiration_date: string = TealiumConstants.emptyData;   //Required * (dont have)
    customer_expiration: string = TealiumConstants.emptyData;        //Required * (dont have)
    customer_enrollment_date: string = TealiumConstants.emptyData;   //Required * (dont have)
    customer_status: string = TealiumConstants.emptyData;            //Required *
    customer_dbc_balance: string = TealiumConstants.emptyData;                                           //Suggested *
    customer_vacation_cash_balance: string = TealiumConstants.emptyData;                                 //Suggested *
    customer_point_balance: string = TealiumConstants.emptyData;                                         //Suggested *
    customer_renewal_price: string = TealiumConstants.emptyData;                                         //Suggested *
    customer_credits: string = TealiumConstants.emptyData;                                               //Suggested *
    login_status: string = TealiumConstants.emptyData;               //Suggested *
    customer_email: string = TealiumConstants.emptyData;                                                 //Suggested *
    customer_phone: string = TealiumConstants.emptyData;                                                 //Suggested *
    customer_state: string = TealiumConstants.emptyData;                                                 //Suggested *
    customer_city: string = TealiumConstants.emptyData;                                               //Suggested *
    customer_postal_code: string = TealiumConstants.emptyData;                                         //Suggested *
    customer_first_name: string = TealiumConstants.emptyData;                                           //Suggested *
    customer_last_name: string = TealiumConstants.emptyData;                                             //Suggested *
    customer_country: string = TealiumConstants.emptyData;                                               //Suggested *
    name_id: string = TealiumConstants.emptyData;                                                        //Suggested *
    customer_type: string = TealiumConstants.emptyData;              //Suggested NA
    partner_id: string = TealiumConstants.emptyData;                                                     //Suggested *
}

export class VirtualPageProperties {
    page_name: string = TealiumConstants.emptyData;                  //Required *
    page_type: string = TealiumConstants.emptyData;                  //Required *
    site_section: string = TealiumConstants.emptyData;               //Required
    date: string = TealiumConstants.emptyData;
    language_code: string = TealiumConstants.emptyData;
    product_name: string = TealiumConstants.emptyData;               //Required *
    country_code: string = TealiumConstants.emptyData;
}

export class AgentProperties {
    agent_email: string = TealiumConstants.emptyData;
    agent_first_name: string = TealiumConstants.emptyData;
    agentFullName: string = TealiumConstants.emptyData;
    agent_assist_date: string = TealiumConstants.emptyData;
    agent_last_name: string = TealiumConstants.emptyData;
    agent_phone: string = TealiumConstants.emptyData;
}

export class DisplayOptionsProperties {
    "dl_display_options.Locale": string;        //Required *
    "dl_display_options.currency_code": string; //Required *
}

export class ResortProperties {
    property_brand: string = TealiumConstants.emptyData;                     //Required
    property_city: string = TealiumConstants.emptyData;                      //Required *
    property_state: string = TealiumConstants.emptyData;                     //Required *
    property_country: string = TealiumConstants.emptyData;                   //Required *
    property_id: string = TealiumConstants.emptyData;                        //Required *
    property_name: string = TealiumConstants.emptyData;                      //Required *
    property_postal_code: string = TealiumConstants.emptyData;               //Required: * is it okay to provide lng/lat
    property_room_occupancy: any[];             //Required 
    property_room_type: any[];
    displayed_rate_amount: string = TealiumConstants.emptyData;
    displayed_room_rates: any[];
    displayed_room_types: any[];
    favorite_property_id: string = TealiumConstants.emptyData;
}

export class OrderProperties {
    order_payment_type: string = TealiumConstants.emptyData;             //Required * Credit Card/Vacation Cash
    order_promo_code: string = TealiumConstants.emptyData;               //Required * We don't have Promo codes, Certificates is the closest we have.
    order_store: string = TealiumConstants.emptyData;                    //Required * Cobrand.Id
    order_sub_total: string = TealiumConstants.emptyData;                //Required * Total - Taxes and Fees
    order_subtotal: string = TealiumConstants.emptyData;                 //Required * Total - Taxes and Fees
    order_tax_amount: string = TealiumConstants.emptyData;               //Required * Taxes and Fees
    order_grand_total: string = TealiumConstants.emptyData;              //Required * Toatal ( AI, CertRFee, Insurance, -Discount)
    order_id: string = TealiumConstants.emptyData;                       //Required - Available after booking.
    order_cancellation_policy: string[];    //Required - Not Available
    order_corp_id: string = TealiumConstants.emptyData;                  //Suggested
    order_discount_amount: string = TealiumConstants.emptyData;          //Suggested * Discount
    order_iata: string = TealiumConstants.emptyData;                     //Suggested * Is it relevant for Resort ??
    order_points_used: string = TealiumConstants.emptyData;              //Suggested *
    order_rate_code: string[];              //Suggested 
    order_special_requests: string = TealiumConstants.emptyData;         //Suggested * closest is comments field.
    order_total_occupancy: string = TealiumConstants.emptyData;          //Suggested * guests.length
    number_of_nights: string = TealiumConstants.emptyData;
    num_of_nights: string = TealiumConstants.emptyData;
    number_of_rooms: string = "1";
    checkout_step: string = TealiumConstants.emptyData;
    trip_start_date: string = TealiumConstants.emptyData;
    trip_end_date: string = TealiumConstants.emptyData;
    total_passengers: string = TealiumConstants.emptyData;
    product_type: string = TealiumConstants.emptyData;
}

export class CheckoutProperties {
    "checkout_step": string;                //Required
    "country_code": string;                 //Suggested
    customer: MemberProperties;
    displayOptions: DisplayOptionsProperties;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/instrumentation/tealium/tealium-data-points.model.ts